<template>
<div id="purchase-edit">
  <h2>Edit Purchase #{{ purchaseId }}</h2>

  <purchase-nav
    :purchaseId="purchaseId"
  ></purchase-nav>

  <purchase-form
    :purchaseId="purchaseId"
  ></purchase-form>
</div>
</template>

<script>
import PurchaseForm from '@/components/PurchaseForm'
import PurchaseNav from '@/components/PurchaseNav'

export default {
  components: {
    'purchase-form': PurchaseForm,
    'purchase-nav': PurchaseNav
  },

  props: ['purchaseId'],

  created () {
    this.$forceUpdate()
    this.$on('processErrors', this.$parent.processErrors)
  },

  watch: {
    '$route' (to, from) {
      this.get()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PurchaseEdit.vue